module.exports = __webpack_public_path__ + "static/media/irvingPic.0fc8d1e0.jpg";